import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AgencyreportComponent } from './agencyreport.component';

const routes: Routes = [{ path: '', component:AgencyreportComponent,pathMatch: "full"}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgencyreportRoutingModule { }
